export const ErrorMapperAccountConst = {
    20001: /* translationId */ 'ERRORS.20001',
    20005: /* translationId */ 'ERRORS.20005',
    20301: /* translationId */ 'ERRORS.20301'
};
